import { createRoute, Outlet, useNavigate } from "@tanstack/react-router";
import { useSession } from "@/auth/client";
import { AppLayout } from "@/components/layout/app-layout";
import { Route as rootRoute } from "./__root";

export const Route = createRoute({
  getParentRoute: () => rootRoute,
  id: "_authenticatedFullBleed",
  component: AuthenticatedFullBleedLayout,
});

function AuthenticatedFullBleedLayout() {
  const { data: session, isPending } = useSession();
  const navigate = useNavigate();

  if (isPending) {
    return (
      <div className="min-h-screen flex items-center justify-center">
        <div className="text-muted-foreground">Loading...</div>
      </div>
    );
  }

  if (!session?.user) {
    navigate({ to: "/" });
    return null;
  }

  return (
    <AppLayout fullBleed>
      <Outlet />
    </AppLayout>
  );
}
